import api from "../axios";

export const getSubCategoryData = ({ subCategory }) => {
  const res = api.get("/subcategory/getSubCategoryData", {
    params: {
      sub_category: subCategory,
    },
  });

  return res;
};

export const getProductsUnderSubCategory = ({ subCategory }) => {
  const res = api.get("/subcategory/getProductsAgainstSubCategory", {
    params: {
      sub_category: subCategory,
    },
  });

  return res;
};
